import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { apiSlice } from "./apiSlice";
import { tokenAuthApi } from "./services/tokenAuthService";
import setMenuSlice from "./setMenuSlice";
import cartListReducer from "./cartSlice";
import localCartListReducer from "./locallCartSlice";
import restaurantReducer from "./restaurantSlice";
import customerReducer from "./customerSlice";
import notificationSlice from "./notificationSlice";
import ordersReducer from "./ordersSlice";
import initialDataSlice from "./initialDataSlice";
import orderTypeReducer from "./orderTypeSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "restaurant",
    "category",
    "cartList",
    "localCartList",
    "customer",
    "orders",
    "initialData",
    "orderType",
  ],
};

const rootReducer = combineReducers({
  setMenu: setMenuSlice,
  cartList: cartListReducer,

  localCartList: localCartListReducer,
  restaurant: restaurantReducer,
  customer: customerReducer,
  notification: notificationSlice,
  orders: ordersReducer,
  initialData: initialDataSlice,
  orderType: orderTypeReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [tokenAuthApi.reducerPath]: tokenAuthApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware, tokenAuthApi.middleware),
  devTools: process.env.NODE_ENV !== 'production'
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


